import React from "react";
import { FlatList, Image, Platform, StyleSheet, Text, TouchableOpacity, View } from "react-native";
import { Body, Button, Container, Footer, Title } from "native-base";
import SpokenReadingResultView, { WavingLineWrapper } from "./share/SpokenReadingResultView";
import { withTranslation } from "react-i18next";
import _ from "lodash";
import Icon from "react-native-vector-icons/Ionicons";
import Video from "react-native-video";
import Loading from "../../../components/general/Loading";
import Header from "../../../components/ui/WrappedHeader";
import * as Helper from "../../../utils/Helper";
import { EnumHasFlag, GetPlainTextFromSentence } from "../../../utils/MarkTextHelper";
import Constants from "../../../config/Constants";
import SpokenStyle from "../../course/units/SpokenStyle";
import { Avartar, PlayingAudio } from "../../course/units/base/SpokenReadingUnit";
import LoadingIndicator from "../../../components/ui/LoadingIndicator";
import CommonModal from "../../../components/ui/CommonModal";
import { NavigationService } from "../../../navigation";
import UIDs from "../../../UIDs";
import AppConfig from "../../../config/AppConfig";
import PracticeResultService from "../../../services/screens/homework/PracticeResultService";
import SimpleSentence from "../../../components/ui/SimpleSentence";
import NextButtonStyle from "../NextButtonStyle";

const uid = UIDs.screens.homework.resultviews.pska1resultview;
const isIos = Platform.OS === "ios";

class DisplayChars extends React.Component {
    constructor(props) {
        super(props);
    }

    shouldComponentUpdate(nextProps, nextState) {
        if (this.props.displayChars !== nextProps.displayChars) {
            return true;
        }
        if (!_.isEqual(this.props.displayChars, nextProps.displayChars)) {
            return true;
        }
        return false;
    }

    render() {
        const { displayChars, keywords } = this.props;
        return (
            <View style={[SpokenStyle.dialogText, { flexDirection: "row", display: "flex", flexWrap: "wrap" }]}>
                {/* <Text style={[SpokenStyle.dialogsFontSize, SpokenStyle.dialogsLineHeight]}> */}
                {displayChars &&
                    displayChars.map((chars, idx) => {
                        return keywords.includes(chars) ? (
                            chars.split("").map((one, i) => {
                                return (
                                    <SimpleSentence
                                        key={`${idx}${i}`}
                                        style={[SpokenStyle.dialogsFontSize, SpokenStyle.dialogsLineHeight, SpokenStyle.dialogContentChars, SpokenStyle.dialogContentKeyChars]}>
                                        {one}
                                    </SimpleSentence>
                                );
                            })
                        ) : (
                            <SimpleSentence key={idx} style={[SpokenStyle.dialogsFontSize, SpokenStyle.dialogsLineHeight, SpokenStyle.dialogContentChars]}>
                                {chars}
                            </SimpleSentence>
                        );
                    })}
                {/* </Text> */}
            </View>
        );
    }
}

class PSKA1ResultView extends SpokenReadingResultView {
    constructor(props) {
        super(props);

        let { unitType, dialogs = [], useState, vipEnabled, practiceType, practiceRole } = props.data || {};
        let { files, answer } = _.cloneDeep(props.result) || {};
        if (!files) files = [];
        if (!answer) answer = [];

        /*let oriFiles = dialogs.map((dialog, index) => {
            if (practiceRole === 100 || dialog.role === practiceRole) {
                let idx = answer.findIndex(a => a.dialogIndex === index);
                return files[idx]
            } else {
                return dialog.sentences.map(sentence => sentence.audioPath);
            }
        });*/
        let oriFiles = files;
        let remoteFiles = [];
        let answerChars = [];
        let answerDialogIndex = [];

        answer.forEach(({ dialogIndex, result, wavFilePath, audioPath }, index) => {
            files[index] = audioPath;
            remoteFiles[index] = audioPath;
            if (result && result.sentence && result.sentence.length <= 0 && result.rawResult && result.rawResult !== "") {
                answerChars.push(result.rawResult);
                answerDialogIndex.push(dialogIndex);
            }

            if (!this.props.readonly) {
                if (oriFiles[index] && wavFilePath) {
                    oriFiles[index] = wavFilePath;
                }
            }
        });

        let initialGenerate = true;
        if (answerChars.length > 0 && answerChars.length === answerDialogIndex.length) {
            initialGenerate = false;
        }

        const displayDialogs = [];
        dialogs.forEach((item, index) => {
            let newData = {
                chars: item.sentences.map(s => s.chars.join("")).join(""),
                translation: item.sentences.map(s => Helper.translateChinese(s.translation)).join(""),
                role: item.role,
                audioPath: item.sentences.map(s => s.audioPath),
            };

            let findAnswer = answer.find(a => a.dialogIndex === index);
            if (findAnswer) {
                let idx = answer.findIndex(a => a.dialogIndex === index);
                if (files[idx]) {
                    newData.audioPath = files[idx];
                }
                if (findAnswer.result && JSON.stringify(findAnswer.result) !== "{}") {
                    if (!findAnswer.result.rawResult || findAnswer.result.rawResult === "" || findAnswer.result.rawResult === null) {
                        newData.chars = "error";
                    } else {
                        newData.chars = findAnswer.result.rawResult;
                        if (findAnswer.result.sentence && findAnswer.result.sentence.translation) {
                            newData.translation = Helper.translateChinese(findAnswer.result.sentence.translation);
                        }
                    }
                } else {
                    newData.chars = "error";
                }
            } else {
                if (item.role === practiceRole || practiceRole === 100) {
                    newData.chars = "error";
                    newData.audioPath = "";
                }
            }

            displayDialogs.push(newData);
        });

        this.state = {
            ...this.state,
            curPlayKind: "all",
            paused: true,
            curPlayUserIndex: "",
            currentPlayingSource: "",
            currentIndex: 0,
            playList: oriFiles,
            remoteFiles: remoteFiles,
            playOneList: null,
            displayDialogs: displayDialogs,
            curReAudioIndex: null,
            recordingStatus: false,
            volume: 0,
            answer,
            initialGenerate,
            preResult: props.result,
        };

        this.localVars = {
            ...this.localVars,
            dialogs,
            useState,
            vipEnabled,
            practiceRole,
            practiceType,
            answerChars,
            answerDialogIndex,
            practiceAll: practiceRole === 100, //所有角色的值
        };
    }

    getUserResultFull() {
        let answerArr = [];
        let fileArr = [];
        let { practiceRole = 1 } = this.props.data;

        if (this.state.displayDialogs.length > 0) {
            this.state.displayDialogs.forEach(({ role, sentence, audioPath }, dialogIndex) => {
                if (role === practiceRole || this.localVars.practiceAll) {
                    let { result = {} } = this.state.answer.find(item => item.dialogIndex === dialogIndex) || {};
                    result = {
                        result: {
                            ...result,
                        },
                        dialogIndex,
                    };
                    fileArr.push(audioPath);
                    answerArr.push(result);
                }
            });
        }

        return { files: fileArr, answer: answerArr, score: null };
    }

    get userResult() {
        var r = this.getUserResultFull();

        // 返回给服务器的数据, 去掉files
        delete r.files;

        // 重新设置audioPath为remote地址
        r.answer = _.cloneDeep(r.answer);
        r.answer.forEach((it, index) => {
            it.audioPath = this.state.remoteFiles[index];
        });
        return r;
    }

    _handleClose = () => {
        //report result before close

        this.processUnitResult(this.userResult);
        this.close();
    };

    _handleContinue = () => {
        //report result and next
        if (this.state.displayDialogs) {
            for (let i = 0; i < this.state.displayDialogs.length; ++i) {
                let item = this.state.displayDialogs[i];
                let element = item;
                let chars = element.chars;
                if (_.isArray(chars)) {
                    chars = _.join(chars, "");
                }
                let err = chars === "error";
                if (err) {
                    var options = {
                        body: <Text>{this.props.t("hasRecognizeError")}</Text>,
                        showConfirmButton: true,
                        showCancelButton: true,
                        confirmButtonText: this.props.t("continueWork"),
                        cancelButtonText: this.props.t("nextUnit"),
                        onCancelButtonPress: () => {
                            this._handleCloseCommonModal();
                            this.processUnitResult(this.userResult);
                            this._handleStopAudio(this.continue);
                        },
                        onConfirmButtonPress: this._handleCloseCommonModal,
                        tapOutsideCloseCallBack: this._handleCloseCommonModal,
                    };
                    this.localVars.commonModalRef.show(options);
                    this.props.showCommonModalRef(true);
                    return;
                }
            }
        }

        console.log("this.userResult======");
        console.log(this.userResult);
        console.log(this.userResult.answer);
        this.processUnitResult(this.userResult);
        this._handleStopAudio(this.continue);
    };

    _handleCloseCommonModal = () => {
        this.localVars.commonModalRef.hide();
        this.props.showCommonModalRef(false);
    };

    _handleRerecording = () => {
        this.restart();
    };

    componentDidMount() {
        super.componentDidMount();

        if (!this.state.initialGenerate) {
            this._generateTranslation(this.localVars.answerChars, this.localVars.answerDialogIndex, newState => this.setState({ ...newState, initialGenerate: true }));
        }

        this.props.onMounted && this.props.onMounted(this);
    }

    _renderItem = ({ item, index }) => {
        let element = item;
        let chars = element.chars;
        let translation = element.translation;
        let role = element.role;
        let leftOrRight = "left";
        if (role === this.localVars.practiceRole || this.localVars.practiceAll) {
            leftOrRight = "right";
        }
        let isUser = false;
        if (this.localVars.practiceAll || role === this.localVars.practiceRole) {
            isUser = true;
        }
        if (_.isArray(chars)) {
            chars = _.join(chars, "");
        }
        let err = chars === "error";
        let errMsg = null;
        if (err) {
            let findAnswerOne = this.state.answer.find(a => a.dialogIndex === index);
            if (findAnswerOne && findAnswerOne.result && findAnswerOne.result.error) {
                try {
                    errMsg = JSON.parse(findAnswerOne.result.error.message || null);
                } catch {
                    errMsg = { code: findAnswerOne.result.error.code, desc: findAnswerOne.result.error.message };
                }
            }
        }

        let errorTranslation = translation === "error_999";
        let errorTranslationMsg = null;
        if (errorTranslation) {
            let findAnswerOneTranslation = this.state.answer.find(a => a.dialogIndex === index);
            if (findAnswerOneTranslation && findAnswerOneTranslation.result && findAnswerOneTranslation.result.error) {
                errorTranslationMsg = JSON.parse(findAnswerOneTranslation.result.error.message || null);
            }
        }
        let audioPath = element.audioPath;

        chars = GetPlainTextFromSentence(chars);

        let keywords = [];
        let noHaveKeys = [];
        let displayChars = [];
        if (this.localVars.practiceType === 1) {
            //如果显示关键词
            this.localVars.dialogs[index].sentences.map(sentence =>
                sentence.words.map(word => {
                    if (EnumHasFlag(word.command, Constants.TEXT_MARK_TYPE.KEYWORD)) {
                        let keys = word.chars.join("");
                        if (!keywords.includes(keys)) {
                            keywords.push(keys);
                        }
                    }
                })
            );

            keywords.sort(function(a, b) {
                return a.length < b.length;
            });

            keywords.map(word => {
                chars = chars.replace(new RegExp(word, "g"), "_" + word + "_");
                if (chars.indexOf(word) < 0) {
                    noHaveKeys.push(word);
                }
            });

            chars = chars.split("_");
            chars.map(char => {
                if (keywords.includes(char)) {
                    displayChars.push(char);
                } else {
                    char.split("").map(one => {
                        displayChars.push(one);
                    });
                }
            });
        } else {
            displayChars = chars.split("");
        }
        return (
            <View key={index} style={{ flexDirection: leftOrRight === "left" ? "row" : "row-reverse", justifyContent: "flex-start", alignItems: "center", marginVertical: 10 }}>
                <View style={{ alignSelf: "flex-start", opacity: isUser ? 100 : 0.6 }}>
                    <Avartar role={role} nickNames={this.props.data.nickNames} />
                </View>
                <View style={leftOrRight === "left" ? SpokenStyle.dialogContentViewLeft : SpokenStyle.dialogContentViewRight}>
                    <View style={[leftOrRight === "left" ? { alignSelf: "flex-start" } : { alignSelf: "flex-end" }, { flex: 1 }]}>
                        <View style={[leftOrRight === "left" ? { alignSelf: "flex-start" } : { alignSelf: "flex-end" }, { flex: 8 }]}>
                            {!this.state.paused && audioPath.includes(this.state.currentPlayingSource) ? (
                                <TouchableOpacity
                                    disabled={this.isRecording()}
                                    onPress={() => this._handleStopAudio()}
                                    style={[leftOrRight === "left" ? SpokenStyle.dialogAudioLeft : SpokenStyle.dialogAudioRight]}>
                                    <Icon size={13} name={"md-square"} style={[SpokenStyle.labaStop]} />
                                </TouchableOpacity>
                            ) : (
                                <TouchableOpacity
                                    disabled={this.isRecording() || (!audioPath)}
                                    onPress={() => this._handlePlayAudio("one", audioPath, index)}
                                    style={[leftOrRight === "left" ? SpokenStyle.dialogAudioLeft : SpokenStyle.dialogAudioRight]}>
                                    <Icon size={22} name="ios-volume-high" style={[SpokenStyle.labaOrange]} />
                                </TouchableOpacity>
                            )}
                            {!this.props.readonly && err && audioPath && !_.startsWith(audioPath, "~/") && (
                                <TouchableOpacity
                                    disabled={this.isRecording()}
                                    onPress={() => this._handleReIdentification(audioPath, index)}
                                    style={[leftOrRight === "left" ? SpokenStyle.dialogRefreshLeft : SpokenStyle.dialogRefreshRight]}>
                                    <Icon name="md-refresh-circle" size={22} style={{ color: "#22D59E" }} />
                                </TouchableOpacity>
                            )}
                            <View
                                style={[
                                    this.localVars.practiceAll ? SpokenStyle.dialogOwn : leftOrRight === "left" ? SpokenStyle.dialogOther : SpokenStyle.dialogOwn,
                                    leftOrRight === "left" ? { alignSelf: "flex-start" } : { alignSelf: "flex-end" },
                                ]}>
                                {isUser ? (
                                    this.state.curReAudioIndex === index ? (
                                        <View style={[SpokenStyle.dialogOwn, { flex: 8 }]}>
                                            {this.localVars.practiceType === 1 ? (
                                                <>
                                                    <View style={[styles.flexDirection, { flex: 1, flexWrap: "wrap", padding: 5 }]}>
                                                        <SimpleSentence style={[SpokenStyle.dialogsFontSize, SpokenStyle.dialogsLineHeight, SpokenStyle.dialogKey]}>
                                                            {this.props.t("keywords")}
                                                            {keywords && keywords.length > 0 ? (
                                                                keywords.map((keyword, idx) => {
                                                                    return (
                                                                        <SimpleSentence key={idx} style={[SpokenStyle.dialogsFontSize, SpokenStyle.dialogsLineHeight, SpokenStyle.keywords]}>
                                                                            ({keyword})
                                                                        </SimpleSentence>
                                                                    );
                                                                })
                                                            ) : (
                                                                <SimpleSentence style={[SpokenStyle.dialogsFontSize, SpokenStyle.dialogsLineHeight, SpokenStyle.keywordsNo]}>
                                                                    ({this.props.t("noKey")})
                                                                </SimpleSentence>
                                                            )}
                                                        </SimpleSentence>
                                                    </View>
                                                    <View
                                                        style={[
                                                            SpokenStyle.dialogsFontSize,
                                                            SpokenStyle.dialogsLineHeight,
                                                            SpokenStyle.dialogOwnBottom,
                                                            { minHeight: 60, paddingTop: this.state.recordingStatus ? 0 : 10 },
                                                        ]}>
                                                        <View style={[styles.centerAlign, { flex: 1, overflow: "hidden", position: "relative", width: document.getElementById("mobileRoot").offsetWidth - 130, paddingTop: this.state.recordingStatus ? 15 : 0 }]}>
                                                            {this.state.recordingStatus ? (
                                                                <WavingLineWrapper minHeight={50} color="#66bb6a" onEnd={this._handleEndRecord} title={this.props.t("ClickToStop")} />
                                                            ) : (
                                                                <Loading transparent />
                                                            )}
                                                        </View>
                                                    </View>
                                                </>
                                            ) : (
                                                <View style={[styles.centerAlign, { flex: 1, overflow: "hidden", position: "relative", width: document.getElementById("mobileRoot").offsetWidth - 130, paddingTop: 10 }]}>
                                                    {this.state.recordingStatus ? (
                                                        <WavingLineWrapper minHeight={50} color="#66bb6a" onEnd={this._handleEndRecord} title={this.props.t("ClickToStop")} />
                                                    ) : (
                                                        <Loading transparent />
                                                    )}
                                                </View>
                                            )}
                                        </View>
                                    ) : (
                                        <>
                                            {err ? (
                                                <View style={{ flexDirection: "row", display: "flex", flexWrap: "wrap", padding: 5, alignItems: "center" }}>
                                                    <SimpleSentence style={[SpokenStyle.dialogsFontSize, SpokenStyle.dialogsLineHeight, { paddingVertical: errMsg ? 0 : 3, paddingHorizontal: 3 }]}>
                                                        <SimpleSentence style={[{ color: "#FF7C5B" }]}>{this.props.t("aiNoRecog")}</SimpleSentence>
                                                        {errMsg ? (
                                                            <SimpleSentence style={[SpokenStyle.dialogText]}>
                                                                ({errMsg.desc}, {errMsg.code})
                                                            </SimpleSentence>
                                                        ) : null}
                                                    </SimpleSentence>
                                                </View>
                                            ) : (
                                                <View style={{ paddingHorizontal: 10, paddingVertical: 4 }}>
                                                    <DisplayChars displayChars={displayChars} keywords={keywords} />
                                                    {translation ? (
                                                        <View style={{ paddingTop: 5 }}>
                                                            {errorTranslation ? (
                                                                <SimpleSentence style={[{ color: "#FF7C5B" }]}>
                                                                    ({errorTranslationMsg.desc}, {errorTranslationMsg.code})
                                                                </SimpleSentence>
                                                            ) : (
                                                                <SimpleSentence style={SpokenStyle.dialogsTranslation}>{translation}</SimpleSentence>
                                                            )}
                                                        </View>
                                                    ) : null}
                                                </View>
                                            )}
                                            {!this.props.readonly && (
                                                <View style={[SpokenStyle.dialogOwnBottom, { height: 45 }]}>
                                                    <Button
                                                        transparent
                                                        disabled={this.isRecording()}
                                                        onPress={() => {
                                                            this._handleRecordOne(index);
                                                        }}
                                                        style={[styles.centerAlign, SpokenStyle.singleRerecordBtn]}>
                                                        <Text style={SpokenStyle.singleRerecordText}>{this.props.t("singleRerecord")}</Text>
                                                    </Button>
                                                </View>
                                            )}
                                        </>
                                    )
                                ) : (
                                    <View style={{ paddingHorizontal: 10, paddingVertical: 3 }}>
                                        <View style={[SpokenStyle.dialogText, { flexDirection: "row", display: "flex", flexWrap: "wrap" }]}>
                                            {/* <Text style={[SpokenStyle.dialogsFontSize, SpokenStyle.dialogsLineHeight]}> */}
                                            {displayChars &&
                                                displayChars.map((chars, idx) => {
                                                    return keywords.includes(chars) ? (
                                                        chars.split("").map((one, i) => {
                                                            return (
                                                                <SimpleSentence
                                                                    key={`${idx}${i}`}
                                                                    style={[
                                                                        SpokenStyle.dialogsFontSize,
                                                                        SpokenStyle.dialogsLineHeight,
                                                                        SpokenStyle.dialogContentChars,
                                                                        SpokenStyle.dialogContentKeyChars,
                                                                    ]}>
                                                                    {one}
                                                                </SimpleSentence>
                                                            );
                                                        })
                                                    ) : (
                                                        <SimpleSentence
                                                            key={idx}
                                                            style={[SpokenStyle.dialogsFontSize, SpokenStyle.dialogsLineHeight, SpokenStyle.dialogContentChars, SpokenStyle.robotFontColor]}>
                                                            {chars}
                                                        </SimpleSentence>
                                                    );
                                                })}
                                            {/* </Text> */}
                                        </View>
                                        {translation ? (
                                            <View style={{ paddingTop: 5 }}>
                                                <SimpleSentence style={[SpokenStyle.dialogsTranslation, SpokenStyle.robotFontColor]}>{translation}</SimpleSentence>
                                            </View>
                                        ) : null}
                                    </View>
                                )}
                            </View>
                        </View>
                        {isUser && keywords && keywords.length > 0 && noHaveKeys.length > 0 ? (
                            <View style={[styles.flexDirection, { flex: 1, marginTop: 5, flexWrap: "wrap" }]}>
                                <SimpleSentence style={[SpokenStyle.dialogsFontSize, SpokenStyle.dialogsLineHeight]}>
                                    <SimpleSentence style={[SpokenStyle.dialogMissWords, { color: "#9B9B9B" }]}>{this.props.t("misskeywords")}</SimpleSentence>
                                    <SimpleSentence style={[SpokenStyle.dialogMissWords, { color: "#FF7C5B" }]}>{_.isArray(noHaveKeys) ? _.join(noHaveKeys, "、") : null}</SimpleSentence>
                                </SimpleSentence>
                            </View>
                        ) : null}
                    </View>
                </View>
            </View>
        );
    };

    render() {
        if (!this.state.initialGenerate) return <LoadingIndicator />;

        let resultView = null;
        if (this.localVars.vipEnabled) {
            resultView = (
                <View style={{ borderTopWidth: 1, borderColor: "#f1f1f1", backgroundColor: "#fff", borderTopLeftRadius: 10, borderTopRightRadius: 10, paddingLeft: 10, paddingRight: 10, flex: 1 }}>
                    <FlatList
                        data={this.state.displayDialogs}
                        horizontal={false}
                        initialNumToRender={5}
                        windowSize={5}
                        keyExtractor={(item, index) => "item_" + index}
                        ListFooterComponent={() => <View style={{ height: 100 }} />}
                        renderItem={this._renderItem}
                    />
                </View>
            );
        }

        let rate = 1;
        if (!this.getUserResultFull().files.includes(this.state.currentPlayingSource)) {
            rate = this.localVars.robotAudioRate;
        }

        const hasAnswer = this.state.playList.length > 0 ? _.isArray(this.state.playList[0]) ? this.state.playList[0][0] : this.state.playList[0] : false;
        return (
            <Container style={[styles.backgroundColor]}>
                <Video
                    key={this.state.currentPlayingSource}
                    audioOnly={true}
                    rate={rate}
                    paused={this.state.paused}
                    source={{ uri: Helper.convertToAbsoluteUrl(this.state.currentPlayingSource) }} // Can be a URL or a local file.
                    ref={self => {
                        this.player = self;
                    }} // Store reference
                    onLoad={data => {
                        this.setState({ audioDuration: (data.duration * 1000) / rate });
                    }}
                    onError={() => {
                        if (!this.state.paused) {
                            this._continuePlayNext();
                        }
                    }}
                />
                {!this.state.paused && this.state.audioDuration > 0 && <PlayingAudio duration={this.state.audioDuration} onEnd={this._continuePlayNext} />}
                {/* <View><Text style={{color:"#848484"}}>{this.state.currentPlayingSource}</Text></View> */}
                {/* {this.TopicModal(this.props.t("topic"))} */}
                {!this.props.readonly && (
                    <Header style={[styles.headerColor]} androidStatusBarColor="#ffffff">
                        <Body style={[styles.headerBody, styles.flexDirection, styles.alignItemsCenter]}>
                            <View style={{ zIndex: 100, width: 50 }}>
                                <Button transparent disabled={this.isRecording()} onPress={() => this._handleClose()} style={{ width: 50 }}>
                                    <Icon style={[styles.closeIcon]} size={40} name="ios-close" />
                                </Button>
                            </View>
                            <View style={{ marginLeft: -50, flex: 1, paddingHorizontal: 20, zIndex: 10 }}>
                                <Title style={[styles.headerTitle]}>{this.props.t("headertitle")}</Title>
                            </View>
                        </Body>
                    </Header>
                )}
                {this.state.showTimeoutTips && (
                    <View
                        style={{
                            position: "absolute",
                            top: 34,
                            width: "100%",
                            zIndex: 999,
                            flexDirection: "row",
                            alignItems: "center",
                            justifyContent: "space-between",
                            backgroundColor: "white",
                            paddingHorizontal: 10,
                            paddingVertical: 5,
                        }}>
                        <Text style={{ marginRight: 15 }}>{this.props.t("timeoutTips", { seconds: AppConfig.MAX_AUDIO_RECORD_LIMIT || 55 })}</Text>
                        <TouchableOpacity style={{ marginLeft: -10 }} disabled={this.isRecording()} onPress={() => this.setState({ showTimeoutTips: false })}>
                            <Icon size={30} name="ios-close" />
                        </TouchableOpacity>
                    </View>
                )}
                <View
                    style={[
                        styles.flexDirection,
                        styles.alignItemsCenter,
                        { width: "100%", marginTop: -5, backgroundColor: "#fff", borderTopWidth: 1, borderColor: "#f1f1f1", paddingTop: 15, paddingBottom: 15, paddingLeft: 10, paddingRight: 10 },
                    ]}>
                    <View style={{ marginRight: 10 }}>
                        <TouchableOpacity
                            disabled={this.isRecording() || (!hasAnswer)}
                            onPress={() => this._handlePlayAudio("all", "", 0)}
                            style={[SpokenStyle.btnPlay, { flexDirection: "row", backgroundColor: hasAnswer ? (!this.state.paused && this.state.curPlayKind === "all" ? "#777" : "#22D59E") : "#ccc" }]}>
                            {!this.state.paused && this.state.curPlayKind === "all" ? (
                                <>
                                    <Icon size={13} name={"md-square"} color="#fff" style={{ marginRight: 10 }} />
                                    <Text style={[SpokenStyle.btnPlayText]}>{this.props.t("stop")}</Text>
                                </>
                            ) : (
                                <>
                                    <Icon size={20} name={"ios-volume-high"} color="#fff" style={{ marginRight: 10 }} />
                                    <Text style={[SpokenStyle.btnPlayText]}>{this.props.t("play")}</Text>
                                </>
                            )}
                        </TouchableOpacity>
                    </View>
                    {this.props.readonly ? (
                        <TouchableOpacity transparent onPress={this.props.showTopic} style={[SpokenStyle.btnTopic, { flexDirection: "row" }]}>
                            <Text style={{ color: "#22D59E", fontWeight: "bold", paddingHorizontal: 21 }}>{this.props.t("topic")}</Text>
                        </TouchableOpacity>
                    ) : (
                        <TouchableOpacity transparent disabled={this.isRecording()} onPress={this._handleRerecording} style={[SpokenStyle.btnTopic, { flexDirection: "row" }]}>
                            <Image source={require("../../../images/homework/re-recorded2.png")} style={{ height: 18, width: 18, marginRight: 3 }}></Image>
                            <Text style={[SpokenStyle.reRecording]}>{this.props.t("rerecording")}</Text>
                        </TouchableOpacity>
                    )}
                </View>
                <View style={[styles.flex6]}>
                    <View style={{ borderTopWidth: 1, borderColor: "#f1f1f1", paddingTop: 15, paddingBottom: 15, paddingLeft: 10, paddingRight: 10 }}>
                        <View style={[styles.row, { justifyContent: "space-between" }]}>
                            <SimpleSentence style={SpokenStyle.errVipMsg}>
                                {this.props.t("aidesc")}
                                {AppConfig.ENABLE_PAYMENT ? this.props.t("vipFunction") : null}
                            </SimpleSentence>
                            { AppConfig.ENABLE_PAYMENT ? (
                                <TouchableOpacity disabled={this.isRecording()} style={{ borderBottomWidth: 1, paddingBottom: 1, borderBottomColor: "#ffb007" }} onPress={() => this._handleBuyVip()}>
                                    <SimpleSentence style={{ color: "#ffb007", fontWeight: "600" }}>{this.props.t("buyVIP")}</SimpleSentence>
                                </TouchableOpacity>
                            ) : null}
                        </View>
                        {AppConfig.ENABLE_PAYMENT ? <SimpleSentence style={SpokenStyle.errVipDateMsg}>{this.localVars.useState}</SimpleSentence>: null}
                    </View>
                    {resultView}
                </View>
                {!this.props.readonly && (
                    <Footer style={{ backgroundColor: "transparent" }}>
                        <View style={[NextButtonStyle.btnNextView]}>
                            <TouchableOpacity transparent disabled={this.isRecording()} onPress={() => this._handleContinue()} style={[NextButtonStyle.btnNext]}>
                                <Text style={NextButtonStyle.btnNextText}>{this.props.t("next")}</Text>
                            </TouchableOpacity>
                        </View>
                    </Footer>
                )}
                <CommonModal childRef={ref => (this.localVars.commonModalRef = ref)} />
            </Container>
        );
    }

    //播放
    _handlePlayAudio = (kind, audioPath, index) => {
        this.props.stopAudio && this.props.stopAudio();
        if (this.player) {
            if (this.state.paused) {
                if (kind === "all") {
                    this.setState({
                        curPlayKind: kind,
                        currentPlayingSource: this.state.playList.length > 0 ? (_.isArray(this.state.playList[0]) ? this.state.playList[0][0] : this.state.playList[0]) : "",
                        currentIndex: 0,
                        paused: false,
                        curPlayUserIndex: "",
                        playOneList: null,
                    });
                } else {
                    this.setState({
                        playOneList: audioPath,
                        curPlayKind: kind,
                        curPlayUserIndex: index,
                        currentPlayingSource: _.isArray(audioPath) ? audioPath[0] : audioPath,
                        currentIndex: "",
                        paused: false,
                    });
                }
            } else {
                if (this.state.curPlayKind === "all") {
                    if (kind === "all") {
                        this._handleStopAudio();
                    } else {
                        //on ios same file seems have caching
                        //use this to avoid this issue
                        this.setState({ currentPlayingSource: "", audioDuration: 0 }, () => {
                            this.setState({
                                playOneList: audioPath,
                                curPlayKind: kind,
                                curPlayUserIndex: index,
                                currentPlayingSource: _.isArray(audioPath) ? audioPath[0] : audioPath,
                                currentIndex: "",
                                paused: false,
                            });
                        });
                    }
                } else {
                    if (kind === "all") {
                        //on ios same file seems have caching
                        //use this to avoid this issue
                        this.setState({ currentPlayingSource: "", audioDuration: 0 }, () => {
                            this.setState({
                                curPlayKind: kind,
                                currentPlayingSource: this.state.playList.length > 0 ? (_.isArray(this.state.playList[0]) ? this.state.playList[0][0] : this.state.playList[0]) : "",
                                currentIndex: 0,
                                paused: false,
                                curPlayUserIndex: "",
                                playOneList: null,
                            });
                        });
                    } else {
                        if (this.state.curPlayUserIndex === index) {
                            this._handleStopAudio();
                        } else {
                            //on ios same file seems have caching
                            //use this to avoid this issue
                            this.setState({ currentPlayingSource: "", audioDuration: 0 }, () => {
                                this.setState({
                                    playOneList: audioPath,
                                    curPlayKind: kind,
                                    curPlayUserIndex: index,
                                    currentPlayingSource: _.isArray(audioPath) ? audioPath[0] : audioPath,
                                    currentIndex: "",
                                    paused: false,
                                });
                            });
                        }
                    }
                }
            }
        }
    };

    _handleStopAudio = callBack => {
        this.setState({ currentIndex: 0, curPlayUserIndex: "", paused: true, currentPlayingSource: "", playOneList: null, audioDuration: 0 }, () => {
            if (this.player) {
                this.player.seek(0);
            }
            callBack && callBack();
        });
    };

    _handleBuyVip = () => {
        this._handleStopAudio();
        NavigationService.navigateToPage(this, UIDs.screens.me.member, { userHomeworkId: this.props.data.userHomeworkId });
    };

    _continuePlayNext = () => {
        //获取当前播放的对话audio列表
        let curPlayList = this.state.playList[this.state.currentIndex];
        if (this.state.curPlayKind !== "all") {
            curPlayList = this.state.playOneList;
        }

        if (!_.isArray(curPlayList)) {
            curPlayList = [curPlayList];
        }

        let audioPath = this.state.currentPlayingSource;
        let sentenceIndex = curPlayList.findIndex(a => a === audioPath);
        if (sentenceIndex === -1) {
            this._handleStopAudio();
            return;
        }
        if (sentenceIndex < curPlayList.length - 1) {
            //如果当前播放的对话audio列表没有播完，继续播列表中的下一个
            this.setState({
                currentPlayingSource: curPlayList[sentenceIndex + 1],
                audioDuration: 0,
            });
        } else {
            //如果当前播放的对话audio列表播放完了， 如果是播放全部，就进入对话的下一句， 否则就结束
            if (this.state.curPlayKind === "all" && this.state.currentIndex < this.state.playList.length - 1) {
                let nextAudioList = this.state.playList[this.state.currentIndex + 1];
                let restAudioPath = _.isArray(nextAudioList) ? nextAudioList[0] : nextAudioList;
                this.setState({
                    currentPlayingSource: restAudioPath,
                    currentIndex: this.state.currentIndex + 1,
                    audioDuration: 0,
                });
            } else {
                //播放完了直接结束
                this._handleStopAudio();
            }
        }
    };

    _handleRecordOne = index => {
        this._handleStopAudio();

        this._handleOneClear();

        this.setState({ recordingStatus: true, curReAudioIndex: index });
        this.recordingTimeout = setTimeout(() => {
            // 显示录音超时提示，在5秒后自动隐藏
            this.setState({ showTimeoutTips: true });
            this._handleEndRecord();
            setTimeout(() => {
                this.setState({ showTimeoutTips: false });
            }, 5000);
        }, (AppConfig.MAX_AUDIO_RECORD_LIMIT || 55) * 1000);

        const fileName = this.state.playList[this.state.answer.findIndex(a => a.dialogIndex === index)];
        this.startRecordAndUpload(
            { fileName },
            (file, response, uploadResponse) => {
                const error = response.error ? response.error : uploadResponse.error;
                if (error) {
                    this.setState({ curReAudioIndex: null });
                    this.displayError({ message: error.toString()});
                    return;
                }

                let list = _.cloneDeep(this.state.playList);
                let remoteFiles = _.cloneDeep(this.state.remoteFiles);
                let idx = this.state.answer.findIndex(a => a.dialogIndex === index);
                list[idx] = file;
                if (uploadResponse.virtualPath) {
                    remoteFiles[idx] = uploadResponse.virtualPath;
                }

                let chars = response.rawResult !== "" && response.rawResult !== null ? response.rawResult : "error";
                //调用翻译接口
                this._generateTranslation([chars], [index], newState => {
                    const { displayDialogs, answer } = newState;
                    displayDialogs[index].audioPath = file;
                    this.setState({ curReAudioIndex: null, playList: list, remoteFiles, displayDialogs, answer });
                });
            },
            () => {
                clearTimeout(this.recordingTimeout);
            }
        );
    };

    _handleReIdentification = (audioPath, index) => {
        this._handleOneClear();

        this.setState({ recordingStatus: false, curReAudioIndex: index });

        this.startReIdentification(audioPath, "", response => {
            if (response.error) {
                this.displayError({ message: response.error.message });
            }

            let chars = response.rawResult && response.rawResult !== "" && response.rawResult !== null ? response.rawResult : "error";
            //调用翻译接口
            this._generateTranslation([chars], [index], newState => {
                const { displayDialogs, answer } = newState;
                this.setState({ curReAudioIndex: null, displayDialogs, answer });
            });
        });
    };

    _handleEndRecord = () => {
        if (this.state.recordingStatus) {
            this.setState({ recordingStatus: false }, this.endRecord);
        }
    };

    _handleOneClear = () => {
        if (this.state.recordingStatus) {
            this.setState({ recordingStatus: false, curReAudioIndex: null }, this.endRecord);
        }
    };

    _generateTranslation = (wordList, dialogIndex, callBack) => {
        PracticeResultService.generateBySentence(
            wordList,
            response => {
                let { words } = response;
                let newDisplayDialogs = Array.from(this.state.displayDialogs);
                let answer = Array.from(this.state.answer);
                for (var i = 0; i < wordList.length; i++) {
                    let answerOne = answer.find(a => a.dialogIndex === dialogIndex[i]);
                    let newSen = words[i];
                    let sentence = {
                        chars: wordList[i],
                        ...newSen,
                        id: Math.random(),
                    };
                    if (answerOne) {
                        answerOne.result.rawResult = wordList[i];
                        answerOne.result.sentence = sentence;
                    } else {
                        let newAnswer = {
                            dialogIndex: dialogIndex[i],
                            result: {
                                rawResult: wordList[i],
                                sentence: sentence,
                            },
                        };
                        answer.push(newAnswer);
                    }
                    newDisplayDialogs[dialogIndex[i]].chars = wordList[i];
                    newDisplayDialogs[dialogIndex[i]].translation = Helper.translateChinese(words[i].translation);
                }
                callBack && callBack({ displayDialogs: newDisplayDialogs, answer });
            },
            error => {
                let answer = Array.from(this.state.answer);
                let newDisplayDialogs = Array.from(this.state.displayDialogs);
                for (var i = 0; i < wordList.length; i++) {
                    let word = wordList[i];
                    let answerOne = answer.find(a => a.dialogIndex === dialogIndex[i]);
                    let sentence = {
                        chars: wordList[i],
                        translation: "error_999",
                    };

                    let err = {
                        desc: error.message ? error.message : "Generate words[" + word + "] message error",
                        code: error.code,
                        id: Math.random(),
                    };

                    let message = { message: JSON.stringify(err) };

                    if (answerOne) {
                        answerOne.result.rawResult = "error";
                        answerOne.result.sentence = sentence;
                        answerOne.result.error = message;
                    } else {
                        let newAnswer = {
                            dialogIndex: dialogIndex[i],
                            result: {
                                rawResult: "error",
                                sentence: sentence,
                                error: message,
                            },
                        };
                        answer.push(newAnswer);
                    }
                    newDisplayDialogs[dialogIndex[i]].chars = wordList[i];
                    newDisplayDialogs[dialogIndex[i]].translation = "error_999";
                }
                callBack && callBack({ displayDialogs: newDisplayDialogs, answer });
            }
        );
    };

    isRecording = () => {
        if (this.state.recordingStatus || this.state.curReAudioIndex !== null) {
            return true;
        }
        return false;
    };

    //override
    backgroundStopRecordCallback = () => {
        this.resetScreen(() => {
            if (this.isRecording()) {
                this._handleOneClear();
            }
            if (this.recordingTimeout) {
                clearTimeout(this.recordingTimeout);
            }
        });
    };
}

const styles = StyleSheet.create({
    row: {
        flexDirection: "row",
    },
    centerAlign: {
        justifyContent: "center",
        alignItems: "center",
    },
    alignItemsCenter: {
        alignItems: "center",
    },
    flex1: {
        flex: 1,
    },
    flex2: {
        flex: 2,
    },
    flex6: {
        flex: 6,
    },
    closeIcon: {
        color: "#000",
    },

    backgroundColor: {
        backgroundColor: "#fff",
    },

    headerColor: {
        backgroundColor: "#fff",
    },

    headerTitle: {
        color: "#111",
        fontSize: 17,
    },

    flexDirection: {
        flexDirection: "row",
    },

    justifyContentBetween: {
        justifyContent: "space-between",
    },
});

export default withTranslation(uid)(PSKA1ResultView);
